<template>
  <div class="faq">
    <div class="plan-condition py-4 border-b border-section_border">
      <h2 class="section-title text-lg text-center">
        {{$t('tour_faq_title')}}
      </h2>
    
      <div class="p-4 border-b border-section_border">
        <div class="p-4 bg-white rounded-lg">
          <dl>
            <dt class="text-lg font-semibold mb-1">
              {{$t('tour_faq_q1')}}
            </dt>
            <dd class="mb-4 pb-4 border-b border-section_border">
              {{$t('tour_faq_a1')}}
            </dd>
            <dt class="text-lg font-semibold mb-1">
              {{$t('tour_faq_q2')}}
            </dt>
            <dd class="mb-4 pb-4 border-b border-section_border">
              {{$t('tour_faq_a2')}}
            </dd>
            <dt class="text-lg font-semibold mb-1">
              {{$t('tour_faq_q3')}}
            </dt>
            <dd>
              {{$t('tour_faq_a3')}}
            </dd>
          </dl>
        </div>
      </div>

      <div class="mt-4 px-4">
        <a class="button-secondary block button-icon icon-left" @click="back">
          <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
          <span>{{ $t('tour_back_to_plan_top_label') }}</span>
        </a>
      </div>
      <div class="mt-4 px-4">
        <a :href="maas_top_url()" class="button-secondary w-full block button-icon icon-left">
          <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
          <span>{{ $t('tour_maas_top_link') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../constants";

export default {
  methods: {
    back: function () {
      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID){
        this.$router.push({ name: 'plansTop', params: { lang: this.$store.getters['user/getLang'] }})
      }else{
        this.$router.push({ name: 'plansTop', params: { lang: this.$store.getters['user/getLang'], areaId: areaId }})
      }
    },
    maas_top_url: function () {
      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID) {
        return Constants.LINK_BASE_URL + '/'
      } else {
        return Constants.LINK_BASE_URL + '/' + areaId
      }
    }
  }
}
</script>